module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-76x76-precomposed-dbda0ddc.png";